import {
  getGiftCardData,
  addGiftCardData,
  editGiftCardData,
  deleteGiftCardData,
  getCategoriesData,
  orderGiftCardData
} from '../libs/apis/GiftCardApi';

export const GET_GIFTCARD_REQUEST = 'GET_GIFTCARD_REQUEST';
export const GET_GIFTCARD_SUCCESS = 'GET_GIFTCARD_SUCCESS';
export const GET_GIFTCARD_FAILURE = 'GET_GIFTCARD_FAILURE';

export const ADD_GIFTCARD_REQUEST = 'ADD_GIFTCARD_REQUEST';
export const ADD_GIFTCARD_SUCCESS = 'ADD_GIFTCARD_SUCCESS';
export const ADD_GIFTCARD_FAILURE = 'ADD_GIFTCARD_FAILURE';

export const EDIT_GIFTCARD_REQUEST = 'EDIT_GIFTCARD_REQUEST';
export const EDIT_GIFTCARD_SUCCESS = 'EDIT_GIFTCARD_SUCCESS';
export const EDIT_GIFTCARD_FAILURE = 'EDIT_GIFTCARD_FAILURE';

export const ORDER_GIFTCARD_REQUEST = 'ORDER_GIFTCARD_REQUEST';
export const ORDER_GIFTCARD_SUCCESS = 'ORDER_GIFTCARD_SUCCESS';
export const ORDER_GIFTCARD_FAILURE = 'ORDER_GIFTCARD_FAILURE';

export const DELETE_GIFTCARD_REQUEST = 'DELETE_GIFTCARD_REQUEST';
export const DELETE_GIFTCARD_SUCCESS = 'DELETE_GIFTCARD_SUCCESS';
export const DELETE_GIFTCARD_FAILURE = 'DELETE_GIFTCARD_FAILURE';

export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIESREQUEST';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE';

export const getGiftCard = params => dispatch => {
  dispatch({ type: GET_GIFTCARD_REQUEST });
  return getGiftCardData(params)
    .then(response =>
      dispatch({
        type: GET_GIFTCARD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GIFTCARD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGiftCard = params => dispatch => {
  dispatch({ type: ADD_GIFTCARD_REQUEST });
  return addGiftCardData(params)
    .then(response =>
      dispatch({
        type: ADD_GIFTCARD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GIFTCARD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGiftCard = (id, params) => dispatch => {
  dispatch({ type: EDIT_GIFTCARD_REQUEST });
  return editGiftCardData(id, params)
    .then(response =>
      dispatch({
        type: EDIT_GIFTCARD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GIFTCARD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const orderGiftCard = params => dispatch => {
  dispatch({ type: ORDER_GIFTCARD_REQUEST });
  return orderGiftCardData(params)
    .then(response =>
      dispatch({
        type: ORDER_GIFTCARD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ORDER_GIFTCARD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteGiftCard = id => dispatch => {
  dispatch({ type: DELETE_GIFTCARD_REQUEST });
  return deleteGiftCardData(id)
    .then(response =>
      dispatch({
        type: DELETE_GIFTCARD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_GIFTCARD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getCategories = params => dispatch => {
  dispatch({ type: GET_CATEGORIES_REQUEST });
  return getCategoriesData(params)
    .then(response =>
      dispatch({
        type: GET_CATEGORIES_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_CATEGORIES_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
